personalIdCheckSum = function (x) {
    if(x.length < 1) {
        return false;
    }

    var pcode = x.substr(0, 9);
    var check = parseInt(x.substr(9));
    var sum = 0;
    var temp_var = 0;

    for (var i = 0; i < 9; i++) {
        temp_var = parseInt(pcode[i]) * (i % 2 ? 1 : 2);
        if (temp_var < 10)
            sum += temp_var;
        else {
            sum = sum + parseInt(temp_var.toString()[0]) + parseInt(temp_var.toString()[1]);
        }
    }

    sum = parseInt(sum.toString()[sum.toString().length - 1]);

    if (parseInt(sum) === 0 && check === 0) {
        return true;
    }

    if (10 - parseInt(sum) === check) {
        return true;
    }

    return false;
}
